export const theme = {
  fonts: {
    mainFont: `Open Sans, sans-serif`,
  },
  colors: {
    primary: `#ffcc1b`,
    secondary: `#4160a4`,
  },
};